import type {
  Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../../util/invalidateQuery';
import type {
  RentersInterestedPartyCreateMutation,
  RentersInterestedPartyDeleteMutation,
  RentersInterestedPartyReplaceMutation,
  RentersInterestedPartyUpdateMutation,
} from '../../../generated/graphql';

function invalidateRentersInterestedPartyMutationCache(cache: Cache) {
  invalidateQuery('entity', cache);
}

const rentersInterestedPartyMutations: UpdatesConfig['Mutation'] = {
  rentersInterestedPartyCreate: (data: RentersInterestedPartyCreateMutation, __: Variables, cache: Cache) => {
    if (data.rentersInterestedPartyCreate) {
      invalidateRentersInterestedPartyMutationCache(cache);
    }
  },

  rentersInterestedPartyUpdate: (data: RentersInterestedPartyUpdateMutation, __: Variables, cache: Cache) => {
    if (data.rentersInterestedPartyUpdate) {
      invalidateRentersInterestedPartyMutationCache(cache);
    }
  },

  rentersInterestedPartyReplace: (data: RentersInterestedPartyReplaceMutation, __: Variables, cache: Cache) => {
    if (data.rentersInterestedPartyReplace) {
      invalidateRentersInterestedPartyMutationCache(cache);
    }
  },

  rentersInterestedPartyDelete: (data: RentersInterestedPartyDeleteMutation, __: Variables, cache: Cache) => {
    if (data.rentersInterestedPartyDelete) {
      invalidateRentersInterestedPartyMutationCache(cache);
    }
  },
};

export default rentersInterestedPartyMutations;
